import anime from 'animejs/lib/anime.es.js';
import { getReducedMotion } from '../../utils/animation';

export function HomepageHero() {
	let header = document.querySelector('.a-homepage .c-header');
	let media = document.querySelector('.a-homepage .c-hero__media');
	let content = document.querySelector('.a-homepage .c-hero__content');

	if (!header || !media || !content) {
		return;
	}

	let animation = anime.timeline({
		easing: 'easeInQuad',
		autoplay: false,
	}).add({
		targets: '.c-header',
		delay: 300,
		duration: 600,
		opacity: 1,
	}).add({
		targets: media,
		opacity: 1,
		duration: 1000,
	}, '+=100').add({
		targets: content,
		opacity: 1,
		duration: 600,
		translateY: ['20%', '0%'],
	}, '+=300');

	if (!getReducedMotion()) {
		animation.play();
	} else {
		animation.seek(1 * animation.duration);
	}
}
